import { render, staticRenderFns } from "./LoadingComponent.vue?vue&type=template&id=f413768a&scoped=true&"
import script from "./LoadingComponent.vue?vue&type=script&lang=js&"
export * from "./LoadingComponent.vue?vue&type=script&lang=js&"
import style0 from "./LoadingComponent.vue?vue&type=style&index=0&id=f413768a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f413768a",
  null
  
)

export default component.exports